import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EstatusService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    if(this.authService.getIsAuth()){
      this.obtienInfo();
    }
  }
  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    if(this.idEmpresa == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
      this.idEmpresa=localStorage.getItem('idEmpresa_surveysatus');
    }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

activarEstatusSurvey(datos){
  console.log("open",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionConfirmaEncuesta.activarEstatus + this.idEmpresa + "/" + localStorage.getItem('productoID'),datos);
}
activarEstatusSurveyPulse(datos,idProducto){
  console.log("open",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizarSurveyEstatus + this.idEmpresa + "/" + idProducto,datos);
}

desactivarEstatusSurveyPulse(datos,idProducto){
  console.log("close",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.actualizarSurveyEstatus + this.idEmpresa + "/" + idProducto,datos);
}

desactivarEstatusSurvey(datos){
  console.log("close",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionConfirmaEncuesta.activarEstatus + this.idEmpresa + "/" + localStorage.getItem('productoID'),datos);
}

getEstatusCierreEncuesta(datos:any){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.fechaCierre.getStatusEncuesta+datos);
}

  getResult_Encuesta(idSurvey,instituto,token){
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCol_survey+idSurvey+'/'+instituto+'/'+token);
  }

  guardaStatusConfirmacion(datos){
  // let datos: any = {fechaCertificar: anio,	confirmacion: status};
  this.obtienInfo();
  console.log(datos);
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);

  }
  guardaStatusConfirmacionMedir(datos){
  // let datos: any = {fechaCertificar: anio,	confirmacion: status};
  this.obtienInfo();
  console.log(datos);
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);

  }

  getHistorialActivarDesactivarSurvey(){
  let tipo=3;
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.historialesCer3.getHistorialColActCrea+localStorage.getItem('productoID') + "/"+tipo);
  }

  guardaStatusConfirmacionPulse(idProducto: any,status: number){
    /*let datos: any = {fechaCertificar: anio,	confirmacion: status};
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);*/
    this.obtienInfo();
    let datos: any = {productoId: idProducto,	confirmacion: status};
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }

  getInfoEmpresaConfirmacion(surveyToken:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getInfoEmpresaConfirmacion + surveyToken);
  }
  getproductConfirmData(productoId:any){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getproductConfirmData + this.idEmpresa + "/"+productoId);
  }

  postConfirmData(productoId:any,datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.postConfirmData + this.idEmpresa + "/"+productoId,datos);
  }
}
